import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import CountryBox from '../CountryBox/CountryBox'

const renderCountryField = ({ item }) => (
    <CountryBox label={'country'} value={item?.value || StoreCountry.CountryCapitalize()} />
)

export default renderCountryField

